/** Id del caso (sesión) generado en la tablet: uno por cliente, hasta "Nuevo cliente". */
export function nuevoId(): string {
  try {
    if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) return crypto.randomUUID()
  } catch {
    /* sin crypto.randomUUID: fallback */
  }
  return `caso-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`
}
